export type ColorVariant =
  | "default"
  | "info"
  | "success"
  | "warning"
  | "error"
  | "approved"
  | "new"
  | "live"
  | "partial"
  | "warningAlt"
  | "darkPurple"
  | "lightBlue"

export const ColorMap: Record<string, ColorVariant> = {
  DRAFT: "default",
  PENDING: "warning",
  APPROVED: "success",
  BOOKED: "live",
  LIVE: "live",
  COMPLETED: "info",
  ARCHIVED: "info",
  AUTHORIZED: "info",
  ACTIVE: "success",
  INACTIVE: "error",
  NEW: "new",
  UNDER_REVISION: "warning",
  UNDER_INTERCOMPANY_REVISION: "warning",
  PENDING_REVISION: "warning",
  PENDING_INTERCOMPANY_REVISION: "warning",
  POSTED: "info",
  PARTIALLY_BILLED: "partial",
  BILLED: "info",
  UNBILLED: "warning",
  PAID: "success",
  PARTIALLY_PAID: "partial",
  EXPIRED: "error",
  SUBMITTED: "new",
  UNDER_CHANGE_REQUEST: "warning",
  PENDING_CHANGE_REQUEST: "warning",
  CANCELLED: "error",
  POSTED_FOR_BILLING: "darkPurple",
  MATCHED: "success",
  POST_EVALUATED: "info",
  UNMATCHED: "warningAlt",
  CERTIFIED: "info",
  SEMI_AUTOMATIC: "lightBlue",
  AUTOMATIC: "success",
  "": "default",
} as const

export const colors: Record<ColorVariant, string> = {
  default: "#808080",
  info: "#000",
  success: "#00b1a4",
  approved: "#00b1a4",
  live: "#3ba8d7",
  warning: "#eac24a",
  error: "#d93845",
  new: "#2f7ca3",
  partial: "#bf55f0",
  warningAlt: "#ee8329",
  darkPurple: "#800fb4",
  lightBlue: "#6db9f1",
}

const default_colors_per_type: Record<string, string> = {
  darkBlue: "#48718c",
  lightBlue: "#3ba8d7",
  red: "#d93845",
  darkOrange: "#c75a28",
  lightRed: "#e96e78",
  lightOrange: "#ee8329",
  darkYellow: "#b79145",
  lightYellow: "#eac24a",
  darkPurple: "#800fb4",
  lightPurple: "#bf55f0",
}

export const colorOptions = Object.values(default_colors_per_type)
